export default __webpack_public_path__ + "static/media/Arm-wraps of the Crawling Chaos.7c470b2e.jpg";